<template>
  <div class="main">
    <el-dialog
      :title="openData.title"
      :visible.sync="openData.state"
      :close-on-click-modal="false"
      width="70%"
      class="dialog_container"
      @close="dialogVisibleClone"
    >
      <div class="dialog_content">
        <el-form
          label-position="left"
          label-width="120px"
          ref="formData"
          :model="formData"
          :rules="formDataRules"
        >
          <el-row>
            <el-col :span="10">
              <el-form-item label="机构编码" prop="statNum">
                <el-input
                  :disabled="openData.title == '详情'"
                  v-model.trim="formData.statNum"
                  placeholder="请输入机构编码"
                ></el-input>
              </el-form-item>
              <el-form-item label="机构名称" prop="statName">
                <el-input
                  :disabled="openData.title == '详情'"
                  v-model.number="formData.statName"
                  placeholder="请输入机构名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="机构类型" prop="statType">
                <el-select
                  :disabled="openData.title == '详情'"
                  v-model="formData.statType"
                  placeholder="请选择机构类型"
                  style="width: 100%"
                >
                  <!-- orgList -->
                  <el-option
                    v-for="item in orgList"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="呼叫中心" prop="isCallCenter">
                <el-radio-group v-model="formData.isCallCenter">
                  <el-radio label="1" :disabled="openData.title == '详情'"
                    >是
                  </el-radio>
                  <el-radio label="0" :disabled="openData.title == '详情'"
                    >否
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="机构电话：" prop="phone">
                <el-input
                  :disabled="openData.title == '详情'"
                  v-model.number="formData.phone"
                  :maxlength="11"
                  placeholder="请输入机构电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="区域名称" prop="dataId">
                <!-- <el-input
                                    v-model="formDate.orgName"
                                    disabled
                                ></el-input> -->
                <el-cascader
                  ref="orgId"
                  :disabled="openData.title == '详情'"
                  :show-all-levels="false"
                  v-model="formData.dataId"
                  style="width: 100%"
                  :options="quyuList"
                  :props="{
                    checkStrictly: true,
                    emitPath: false,
                    label: 'label',
                    value: 'orgId',
                  }"
                  clearable
                >
                </el-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="13" :offset="1">
              <el-form-item label="上传图片" prop="photo" align="left">
                <el-upload
                  :disabled="openData.title == '详情'"
                  :action="baseUrl"
                  :show-file-list="false"
                  :on-success="
                    (file, fileList) => {
                      handleAvatarSuccess(file, fileList, 'add')
                    }
                  "
                  :before-upload="beforeAvatarUpload"
                >
                  <div>
                    <div class="avatar" v-if="formData.photo != ''">
                      <img
                        :src="
                          formData.photo == '../../assets/img/user.png'
                            ? ''
                            : formData.photo
                        "
                      />
                    </div>
                    <i
                      v-else
                      class="el-icon-plus avatar_uploader avatar-uploader-icon"
                    ></i>
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="机构地点：">
            <el-button
              type="success"
              class="button"
              size="mmedium"
              style="margin-bottom: 25px"
              @click="mapTap"
              >显示位置</el-button
            >
            <div v-show="showMap">
              <el-row>
                <el-col :span="4">
                  <el-form-item>
                    <el-select
                      v-model="formData.provinceId"
                      placeholder="请选择省"
                      @change="handleProvince"
                      :disabled="
                        normalInfo.orgLevel == 1 ||
                        normalInfo.orgLevel == 2 ||
                        normalInfo.orgLevel == 3 ||
                        normalInfo.orgLevel == 4 ||
                        normalInfo.orgLevel == 5 ||
                        openData.title == '详情'
                      "
                      style="width: 100%"
                      ref="selectShengChange"
                    >
                      <el-option
                        v-for="(item, index) in provinceList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.cityId"
                    placeholder="请选择市"
                    :disabled="
                      normalInfo.orgLevel == 2 ||
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      openData.title == '详情'
                    "
                    @change="handleCity"
                    ref="selectShiChange"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in cityList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.zoneId"
                    placeholder="请选择区"
                    @change="handleArea"
                    :disabled="
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      openData.title == '详情'
                    "
                    ref="selectQuChange"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in areaList"
                      :key="index"
                      :label="item.addName"
                      :value="item.addCode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.streetId"
                    placeholder="请选择街道"
                    :disabled="
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      openData.title == '详情'
                    "
                    @change="streetChange"
                    ref="selectJiedaoChange"
                  >
                    <el-option
                      v-for="item in streetList"
                      :key="item.addCode"
                      :label="item.addName"
                      :value="item.addCode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="formData.shequId"
                    placeholder="请选择社区"
                    :disabled="
                      normalInfo.orgLevel == 5 || openData.title == '详情'
                    "
                    ref="selectShequChange"
                    @change="handleCommunityChange"
                  >
                    <el-option
                      v-for="item in communityList"
                      :key="item.addCode"
                      :label="item.addName"
                      :value="+item.addCode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <input
                v-model.trim="formData.address"
                :disabled="openData.title == '详情'"
                id="tipinput"
                class="el-input__inner"
                :class="openData.title == '详情' ? 'innerCur' : ''"
                @focus="getMap('tipinput')"
                placeholder="请输入关键字"
                autocomplete="off"
              />
              <div class="map_container">
                <div
                  class="map_right"
                  id="container"
                  style="width: 100%; height: 300px"
                ></div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer dialog-footer-btn"
        v-if="openData.title != '详情'"
      >
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialogVisibleClone">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseURL from "@/api/baseURL"
export default {
  props: ["openData",'typeOptions'],
  data() {
    var chekPhone = (rule, value, callback) => {
      let validatePhone = /^1[3|4|5|6|7|8|9]\d{9}$/
      if (!validatePhone.test(value)) {
        return callback(new Error("手机号格式错误"))
      }
      callback()
    }
    return {
      formDate: {},
      showMap: false,
      baseURL: "",
      imageUrl: "",
      orgList: [],
      regionList: [],
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      myMap: null,
      isMap: true,
      polygons: [],
      polygon: [],
      marker: null, //地图标记点
      recMap: null,
      recIsMap: true,
      recPolygons: [],
      recPolygon: [],
      recMarker: null, //地图标记点
      formData: {
        statNum: "",
        statName: "",
        statType: "",
        isCallCenter: "",
        phone: "",
        provinceId: "", //省
        cityId: "", //市
        zoneId: "", //区
        streetId: "", //街道
        shequId: "", //社区
        address: "",
        photo: "",
        dataId: "",
        addressLng: "",
        addressLat: "",
      },
      normalInfo: {},
      formDataRules: {
        //表格表单验证
        statNum: [
          {
            required: true,
            message: "机构编码不能为空",
            trigger: "blur",
          },
        ],
        statName: [
          {
            required: true,
            message: "机构名称不能为空",
            trigger: "blur",
          },
        ],
        statType: [
          {
            required: true,
            message: "机构类型不能为空",
            trigger: "blur",
          },
        ],
        isCallCenter: [
          {
            required: true,
            message: "呼叫中心不能为空",
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: "机构电话不能为空",
            trigger: "blur",
          },
          { validator: chekPhone, trigger: "blur" },
        ],
        // photo: [
        //     {
        //         required: true,
        //         message: "上传图片不能为空",
        //         trigger: "blur",
        //     },
        // ],
        dataId: [
          {
            required: true,
            message: "区域名称不能为空",
            trigger: "blur",
          },
        ],
        quyuList: [],
      },
    }
  },
  created() {
    this.baseUrl = baseURL + "/ypt/controller/uploadController/info/uploadPhoto"
    this.orgList=this.typeOptions
    this.formData = {
      statNum: "",
      statName: "",
      statType: "",
      phone: "",
      provinceId: "", //省
      cityId: "", //市
      zoneId: "", //区
      streetId: "", //街道
      shequId: "", //社区
      address: "",
      photo: "",
      dataId: "",
      addressLng: "",
      addressLat: "",
      isCallCenter: "",
    }
    this.getProvince()
    if (this.openData.title == "新增") {
    } else {
      // setTimeout(async () => {
      //     await this.$nextTick(() => this.loadmap())
      // }, 300)
    }
    this.getOrg()
    this.getArea()
    this.getTree()
  },
  methods: {
    //获取组织机构
    getOrg() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            // this.getProvince()
            this.normalInfo = res.content
            if (this.openData.title == "新增") {
              this.changeFirst()
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    async changeFirst() {
      let province = await this.getDistricts()
      this.provinceList = province.districtList
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistricts(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
        console.log("城市", this.cityList)
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        this.areaList = await this.getStreetList(this.normalInfo.cityId)
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getStreetList(this.normalInfo.areaId)
        this.streetList = streetList
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getStreetList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
        this.provinceList.forEach((item) => {
          if (item.adcode == this.normalInfo.provinceId) {
            // this.formData.addressLat = item.center?.lat
            // this.formData.addressLng = item.center?.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 2) {
        this.cityList.forEach((item) => {
          if (item.adcode == this.normalInfo.cityId) {
            // this.formData.addressLat = item.center.lat
            // this.formData.addressLng = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 3) {
        this.areaList.forEach((item) => {
          if (item.adcode == this.normalInfo.dataId) {
            // this.formData.addressLat = item.center?.lat
            // this.formData.addressLng = item.center?.lng
          }
        })
      } else if (
        this.normalInfo.orgLevel == 4 ||
        this.normalInfo.orgLevel == 5
      ) {
        this.streetList.forEach((item, index) => {
          if (item.addCode == this.normalInfo.streetId) {
            this.formData.addressLat = item.latitude
            this.formData.addressLng = item.longitude
          }
        })
      }

      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = Number(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }
      this.formData.provinceId = this.normalInfo.provinceId
      this.formData.cityId = this.normalInfo.cityId
      this.formData.zoneId = this.normalInfo.areaId
      this.formData.streetId = this.normalInfo.streetId
      this.formData.shequId = this.normalInfo.communityId
      // this.potintMap()
      this.$forceUpdate()
      // console.log(this.normalInfo, "机构信息",this.)
    },
    // 打点
    potintMap() {
      const self = this
      try {
        self.myMap.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [
          Number(this.formData.addressLng),
          Number(this.formData.addressLat),
        ],
      })
      self.myMap.add(self.marker)
      self.myMap.setFitView()
    },
    getTree() {
      this.$post("/rbac/admin/org/info/OrgTreelist", { isValid: 1 }).then(
        (res) => {
          if (res.code === 200) {
            //当前账号绑定的机构所有下级
            this.allList = res.content
            let treeList = []
            this.quyuList = this.chbehavior(
              res.content,
              this.$store.state.info.orgId
            )
            let orgLevel = this.getorgLevel(
              res.content,
              this.$store.state.info.orgId
            )
            if (!this.quyuList.children) {
              //this.quyuList = [];//当前账号绑定的机构没有下级时就置空
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
              })
              this.quyuList = treeList //带同级本身的数据
            } else {
              //this.quyuList = this.quyuList.children;// 不带本身同级，只取下级
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
                children: this.quyuList.children,
              })
              this.quyuList = treeList //带同级本身的数据
            }
          }
        }
      )
    },
    //递归获取当前机构数据
    chbehavior(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },

    //获取当前机构等级
    getorgLevel(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a.orgLevel
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },
    getChildrenId(arr) {
      let res = []
      ;(function deepId(arr) {
        for (let i = 0; i < arr.length; i++) {
          res.push(arr[i].orgId)
          if (arr[i].children) {
            deepId(arr[i].children)
          }
        }
      })(arr)
      return res
    },
    //回显(多级)
    changeDetSelect(value, key, treeData) {
      let arr = [] // 在递归时操作的数组
      let returnArr = [] // 存放结果的数组
      let depth = 0 // 定义全局层级
      // 定义递归函数
      function childrenEach(childrenData, depthN) {
        for (var j = 0; j < childrenData.length; j++) {
          depth = depthN // 将执行的层级赋值 到 全局层级
          arr[depthN] = childrenData[j][key]
          if (childrenData[j][key] == value) {
            returnArr = arr.slice(0, depthN + 1) //将目前匹配的数组，截断并保存到结果数组，
            break
          } else {
            if (childrenData[j].children) {
              depth++
              childrenEach(childrenData[j].children, depth)
            }
          }
        }
        return returnArr
      }
      return childrenEach(treeData, depth)
    },
    // 树转同级
    loopTree(data, arr) {
      data.forEach((item) => {
        arr.push(item)
        if (Array.isArray(item.children)) {
          this.loopTree(item.children, arr)
        }
      })
    },
    // 地图打点
    getMap(input) {
      const self = this
      const autoOptions = {
        city: self.formData.zoneId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.formData.address = e.poi.name
        self.formData.addressLng = e.poi.location.lng
        self.formData.addressLat = e.poi.location.lat
        self.loadmap("container")
        setTimeout(() => {
          self.potintMap()
        }, 500)
      })
    },
    async streetChange(val) {
      this.formData.shequId = ""
      let communityList = await this.getStreetList(val)
      console.log(communityList, "社区列表")
      this.communityList = communityList
      //this.getAddress()
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              // this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.joinAddress()
      })
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取区域名称
    getArea() {
      this.$http
        .request({
          url: "ypt/admin/org/info/findOrg",
          method: "POST",
          data: { pageSize: 50, pageNo: 1, orgLevel: 2 },
        })
        .then((res) => {
          if (res.code == 200) {
            // console.log(res.data, "区域名称")
            if (res.content == null || res.content == "null") {
              this.regionList = []
              return
            }
            this.regionList = res.content.list

            if (this.openData.title != "新增") {
              this.dataInfos()
            }
          }
        })
    },
    // 显示位置
    mapTap() {
      this.showMap = !this.showMap
      if (this.showMap == true) {
        this.loadmap("container")
        setTimeout(() => {
          this.potintMap()
        }, 500)
      }
    },
    // 详情页信息
    dataInfos() {
      const self = this
      let params = {
        id: self.openData.id,
      }
      this.$http
        .request({
          url: "ypt/admin/serviceStation/info/get",
          method: "POST",
          data: params,
        })
        .then(async (res) => {
          if (res.code == 200) {
            let jsonTemp = { ...res.content }
            self.formData.id = jsonTemp.id
            self.formData.photo = jsonTemp.photo
            self.formData.phone = jsonTemp.phone
            self.formData.address = jsonTemp.address
            self.formData.statNum = jsonTemp.statNum
            self.formData.statName = jsonTemp.statName
            self.formData.statType = jsonTemp.statType
            self.formData.isCallCenter = jsonTemp.isCallCenter
            self.formData.dataId = jsonTemp.dataId.toString()
            self.formData.addressLng = jsonTemp.addressLng
            self.formData.addressLat = jsonTemp.addressLat
            self.formData.provinceId = String(jsonTemp.provinceId)
            self.formData.cityId = String(jsonTemp.cityId)
            self.formData.zoneId = String(jsonTemp.zoneId)
            self.formData.streetId = String(jsonTemp.streetId)
            self.formData.shequId = Number(jsonTemp.shequId)
            let province = await self.getDistricts()
            self.provinceList = province.districtList
            console.log(this.provinceList, "省")
            if (!self.formData.provinceId) return
            let city = await self.getDistricts(self.formData.provinceId)
            self.cityList = city.districtList
            if (!self.formData.cityId) return
            self.areaList = await self.getStreetList(self.formData.cityId)
            if (!self.formData.zoneId) return
            let street = await self.getStreetList(self.formData.zoneId)
            self.streetList = street
            if (!self.formData.streetId) return
            // self.streetChange(self.formData.streetId, true)
            let communityList = await self.getStreetList(self.formData.streetId)
            self.communityList = communityList
            console.log(communityList, "communityList")
            if (self.formData.addressLat && self.formData.addressLng) {
              self.loadmap("container")
              setTimeout(() => {
                self.potintMap()
              }, 500)
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },

    //表格表单提交
    handleSubmit() {
      let self = this

      this.$refs.formData.validate((valid) => {
        if (valid) {
          if (this.openData.title == "新增" || this.openData.title == "编辑") {
            let url = ""

            if (!self.formData.provinceId) {
              self.$message.error("省级地址为必填项，请选择")
              return
            }
            if (!self.formData.cityId) {
              self.$message.error("市级地址为必填项，请选择")
              return
            }
            if (!self.formData.zoneId) {
              self.$message.error("区县级地址为必填项，请选择")
              return
            }
            if (!self.formData.streetId) {
              self.$message.error("街道地址为必填项，请选择")
              return
            }
            if (
              self.formData.shequId === "" ||
              self.formData.shequId === null ||
              self.formData.shequId === undefined
            ) {
              self.$message.error(
                "社区为必填项，请选择,如无对应社区，请地址管理配置"
              )
              return
            }
            if (!self.formData.address) {
              self.$message.error(
                "详细信息为必填项，请在地图的边界内点击选择或手动输入"
              )
              return
            }
            // delete this.formData.recTime
            let data = { ...self.formData }
            url = "/ypt/admin/serviceStation/info/save"
            this.$http
              .request({
                url: url,
                method: "POST",
                data: {
                  ...data,
                },
              })
              .then((res) => {
                if (res.code == 200) {
                  this.$message.success(res.message)
                  this.$emit("cancleService", true)
                } else {
                  this.$message.error(res.message)
                }
                this.$emit("cancleService", true)
              })
          }
        }
      })
    },
    // 上传图片前的判断
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!")
        return isJPG
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!")
        return isLt2M
      }
    },
    //自定义图片上传
    handleAvatarSuccess(res, file, name) {
      this.$set(this.formData, "photo", res.content)
    },
    joinAddress(address = "") {
      let self = this
      self.$nextTick(() => {
        let shengName = this.$refs.selectShengChange.selectedLabel
        let shiName = this.$refs.selectShiChange.selectedLabel
        let quName = this.$refs.selectQuChange.selectedLabel
        let jiedaoName = this.$refs.selectJiedaoChange.selectedLabel
        let shequName = this.$refs.selectShequChange.selectedLabel
        if (!address) {
          self.formData.address =
            shengName + shiName + quName + jiedaoName + shequName
        }
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }
        let geocoder = new AMap.Geocoder({ city: "" })
        self.marker = new AMap.Marker()
        geocoder.getLocation(this.formData.address, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            let lnglat = result.geocodes[0].location
            self.formData.addressLng = lnglat.lng
            self.formData.addressLat = lnglat.lat
            self.marker.setPosition(lnglat)
            self.myMap.add(self.marker)
            self.myMap.setFitView(self.marker)
          } else {
            log.error("根据地址查询位置失败")
          }
        })
      })
    },
    //获取地址
    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
            if (bounds) {
              try {
                self.myMap.remove(self.polygons)
              } catch (error) {
                console.log("移除地图编辑出错了")
              }
              self.polygons = []
              for (let i = 0, l = bounds.length; i < l; i++) {
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  strokeColor: "#0091ea",
                  fillColor: "#80d8ff",
                  fillOpacity: 0.4,
                  path: bounds[i],
                })
                self.polygons.push(self.polygon)
                if (!params) {
                  self.polygon.on("click", function (e) {
                    let lnglat = e.lnglat
                    self.myMap.add(self.marker)
                    self.marker.setPosition(lnglat)
                    geocoder.getAddress(lnglat, function (status, result) {
                      if (status === "complete" && result.regeocode) {
                        var address = result.regeocode.formattedAddress
                        self.formData.address = address
                        self.formData.addressLng = lnglat.lng
                        self.formData.addressLat = lnglat.lat
                      } else {
                        console.error("根据经纬度查询地址失败")
                      }
                    })
                  })
                  self.myMap.add(self.polygons)
                  self.myMap.setFitView() //地图自适应
                } else {
                  if (params.addressLng && params.addressLat) {
                    self.myMap.add(self.marker)
                    self.marker.setPosition([
                      params.addressLng,
                      params.addressLat,
                    ])
                    self.myMap.setFitView(self.marker)
                    self.myMap.setZoom(11)
                  }
                }
              }
            }
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    //获取省级
    async getProvince() {
      this.provinceList = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.cityId = ""
      this.formData.zoneId = ""
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
      this.joinAddress()
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.zoneId = ""
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      this.areaList = await this.getStreetList(val)
      this.joinAddress()
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      // val = val.replace(/.$/, "");
      let street = await this.getStreetList(val)
      this.streetList = street
      this.joinAddress()
    },

    //加载地图
    loadmap() {
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map("container", {
          resizeEnable: true,
          zoom: 18,
        })
        resolve()
      })
    },
    // 关闭人员信息
    dialogVisibleClone() {
      this.$emit("cancleService", false)
    },
  },
}
</script>
<style lang="less" scoped>
.avatar {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  line-height: 200px;
  img {
    width: 200px;
    height: 200px;
    line-height: 200px;
    display: block;
  }
}
/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 200px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 200px;
    line-height: 200px;
    text-align: center;
  }
}
.dialog-footer-btn {
  text-align: center;
}
</style>
